import React, { useContext, useState, useEffect, useRef } from "react";

import PostContext from "../../context/post/postContext";
import TagContext from "../../context/tag/tagContext";
import TagsAutoComplete from "./TagsAutoComplete";

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CardMedia from '@mui/material/CardMedia';
import { makeStyles } from "@material-ui/core/styles";
import PhotoCamera from "@material-ui/icons/PhotoCamera";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 2, 3),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 4, 3),
    },
  },
  input: {
    display: "none",
  },
}));

const PostComposerV2 = () => {
  const [file, setFile] = React.useState(null);

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const postContext = useContext(PostContext);
  const tagContext = useContext(TagContext);

  const { addPost, addPostComplete, postAdded } = postContext;
  const { tags, getTags } = tagContext;

  const [tagsState, setTagsState] = useState([]);

  const [isCreatingPost, setIsCreatingPost] = useState(false);

  const ref = useRef();
  const [post, setPost] = useState({
    title: "",
    description: "",
    content: "",
    owner: "",
    cover_photo: null,
  });

  // mimic lifecycle, call when values of dependencies change
  useEffect(() => {
    setPost({
      title: "",
      description: "",
      content: "",
      owner: "",
      cover_photo: null,
    });
  }, [postContext]);

  useEffect(() => {
    getTags();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isCreatingPost && postAdded) {
      setIsCreatingPost(false);
      addPostComplete();
    }
  }, [isCreatingPost, postAdded, addPostComplete]);

  useEffect(() => {
    setPost({
      ...post,
      tags: tagsState,
    });
    //eslint-disable-next-line
  }, [tagsState]);

  const { title, description } = post;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
    setFile(null);
    setPost({
      title: "",
      description: "",
      content: "",
      owner: "",
      cover_photo: null,
      tags: [],
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setIsCreatingPost(true);
    addPost(post);
    ref.current.value = "";
    setOpen(false);
    setFile(null);
  };

  const onChange = (e) =>
    setPost({
      ...post,
      [e.target.name]: e.target.value,
    });

  const onSelectFile = (e) => {
    setPost({
      ...post,
      [e.target.name]: e.target.files[0],
    });
    setFile(e.target.files[0]);
  };

  return (
    <div>
      {isCreatingPost ? (
        <Button
          variant="contained"
          onClick={handleOpen}
          color="primary"
          style={{
            minHeight: "50px",
            background: "#9e9e9e",
          }}
          disabled={isCreatingPost}
          fullWidth
        >
          Uploading
        </Button>
      ) : (
        <Button
          variant="contained"
          onClick={handleOpen}
          color="primary"
          style={{
            minHeight: "50px",
            background: "#03a9f4",
          }}
          disabled={isCreatingPost}
          fullWidth
        >
          New Memory
        </Button>
      )}

      {/* {isCreatingPost ? "Uploading" : ""} */}

      <Dialog
        open={open}
        onClose={handleCancel}
        aria-labelledby="form-dialog-title"
      >
        <div className={classes.paper}>
          <DialogTitle id="form-dialog-title">
            Creating a new memory
          </DialogTitle>
          <br />
          <br />
          <DialogContent>
            <form
              onSubmit={onSubmit}
              encType="multipart/form-data"
              id="post-composer"
            >
              <div>
                <TextField
                  label="title"
                  multiline
                  rowsMax={4}
                  name="title"
                  value={title}
                  onChange={onChange}
                  fullWidth
                  variant="outlined"
                />
              </div>
              <br />
              <div>
                <TextField
                  label="description"
                  multiline
                  rowsMax={10}
                  name="description"
                  value={description}
                  onChange={onChange}
                  fullWidth
                />
              </div>
              <br />
              <TagsAutoComplete
                name="autoTags"
                label="autoTags"
                value={tagsState}
                onChange={onChange}
                addTags={setTagsState}
                existedTags={tags}
              />
              <br />
              <div>
                <input
                  accept="image/*"
                  className={classes.input}
                  id="icon-button-file"
                  type="file"
                  name="cover_photo"
                  onChange={onSelectFile}
                  ref={ref}
                />
                <label htmlFor="icon-button-file">
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                  >
                    <PhotoCamera />
                    {file ? (
                      <div> {file.name}</div>
                    ) : (
                      <div> Upload your photo</div>
                    )}
                  </IconButton>
                </label>
              </div>
              <br />
              <div>
                {file && (
                  <CardMedia
                    image={file ? URL.createObjectURL(file) : null}
                    title={file ? file.name : null}
                    style={{ height: "200px", width: "100%" }}
                  />
                )}
              </div>
              <br />
              <DialogActions>
                <Button onClick={handleCancel} color="primary">
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  form="post-composer"
                >
                  Post
                </Button>
              </DialogActions>
            </form>
          </DialogContent>
        </div>
      </Dialog>
    </div>
  );
};

export default PostComposerV2;
